import { Box, Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./DirectLabsOrderSummary.styles";

interface Props {
  itemType: "test" | "panel";
  name: string;
  price: number;
  testCount: number;
}

const DirectLabsOrderSummary = ({ itemType, name, price, testCount }: Props) => {
  const { t } = useTranslation();
  const formattedPrice = `$${price.toFixed(2)}`;

  const itemTypeLabel =
    itemType === "panel"
      ? t(l.directLabsCheckout.orderSummary.panelLabel)
      : t(l.directLabsCheckout.orderSummary.testLabel);

  return (
    <Box padding="small" customCss={styles.summaryContainer}>
      <Typography variant="h3">{t(l.directLabsCheckout.orderSummary.title)}</Typography>
      <div css={styles.itemDetails}>
        <Typography fontWeight="bold">{name}</Typography>
        <Typography>{itemTypeLabel}</Typography>
        {itemType === "panel" && (
          <Typography>
            {t(l.directLabsCheckout.orderSummary.panelTestCount, { count: testCount })}
          </Typography>
        )}
      </div>
      <div css={styles.totalRow}>
        <Typography>{t(l.directLabsCheckout.orderSummary.subtotal)}</Typography>
        <Typography>{formattedPrice}</Typography>
      </div>
      <div css={styles.totalRow}>
        <Typography>{t(l.directLabsCheckout.orderSummary.taxesEstimated)}</Typography>
        <Typography>{t(l.directLabsCheckout.orderSummary.taxesDeferred)}</Typography>
      </div>
      <div css={styles.totalRow}>
        <Typography as="p" variant="h3">
          {t(l.directLabsCheckout.orderSummary.total)}
        </Typography>
        <Typography as="p" variant="h3">
          {formattedPrice}
        </Typography>
      </div>
    </Box>
  );
};

export { DirectLabsOrderSummary };
